import React, { Component } from 'react'
import { Grid, Header, Modal, Search, Segment, Table, Icon, Button, Confirm, Dimmer, Loader, Label } from 'semantic-ui-react';
import { searchServiceSeller, singleBuyerRequestBidsHistory, updateBidSellerAvailability } from 'services/Manager';
import './ServiceRequestBidHistoryModal.less';
import moment from 'moment-timezone';
import { discountedPriceDisplay, priceDisplay } from 'helpers/price';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import DGDateTimePicker from 'components/FormControls/DateTimePicker/DGDateTimePicker';
import Formsy, { addValidationRule } from 'formsy-react';
import { placeBid } from 'services/Manager';
import { GeneralError } from 'components/GeneralError/GeneralError';
import done from '../../assets/images/newui/done.svg'
import marker_red from '../../assets/images/newui/newrequestpage/marker_red.svg';
import marker_trial_purple from '../../assets/images/newui/newrequestpage/marker_trial_purple.svg';
import marker_green from '../../assets/images/newui/newrequestpage/marker_green.svg';
import { IN_TRIAL } from 'constants/SellerSubscriptionStatus';


const initialState = {
    bids: [],
    searchSellerPhrase: '',
    sellers: [],
    searchingSellers: false,
    selectedSeller: {},
    bidValue: 0,
    sellerAvailability: null,
    loading: false,
    bidSubmissionMessage: '',
    showBidPlacementConfirmation: false,
    loadingText: '',
    windowWidth: window.innerWidth,
    editBidID: 0,
    newSellerAvailability: null,
    existingSellerAvailability: null,
    showAvailabilityUpdateConfirmation: false,
    isUpdated: false
};

addValidationRule('isMoreThanZero', function (values, value, otherField) {
    // The this context points to an object containing the values
    // {childAge: "", parentAge: "5"}
    // otherField argument is from the validations rule ("childAge")
    return Number(value > 0);
});
class ServiceRequestBidHistoryModal extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.bidPriceTextBoxRef = null;
    }

    async componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open && this.props.open === true
            //&& prevProps.singleBuyerRequestID != this.props.singleBuyerRequestID
        ) {
            this.fetchBidHistory();

        }
    }

    fetchBidHistory = async () => {
        this.setState({ loadingText: 'Loading', loading: true })
        const bidHistory = await singleBuyerRequestBidsHistory(this.props.singleBuyerRequestID);
        if (bidHistory.resStatus === 200) {
            this.setState({ bids: bidHistory.data, loading: false, loadingText: '' });
        }
    }

    modalCloseHandler = () => {
        if (!this.state.submittingBid) {
            this.props.onClose(this.state.isUpdated);
            this.resetState();
        }
    }

    onSellerSearchChange = (e, data) => {
        this.setState({ searchSellerPhrase: data.value, searchingSellers: true });
        if (this.searchSellerTimer)
            clearTimeout(this.searchSellerTimer);

        this.searchSellerTimer = setTimeout(() => {
            if (this.state.searchSellerPhrase.length > 0) {
                searchServiceSeller(this.props.serviceid, this.state.searchSellerPhrase).then((response) => {
                    if (response.resStatus === 200) {
                        let sellers = [];
                        response.data.map((seller) => {
                            sellers.push({ id: seller.sellerID, name: seller.name, title: seller.name + ", " + seller.email + ", " + seller.city + ", " + seller.abbreviation, seller: seller });
                        })

                        this.setState({ sellers: sellers });
                    }

                    this.setState({ searchingSellers: false });

                });
            }
            else {
                this.setState({ sellers: [], selectedSeller: {}, searchingSellers: false });
            }

        }, 600);

    }

    onSellerSelection = (e, data) => {

        this.setState({ selectedSeller: data.result, searchSellerPhrase: data.result.name }, () => {
            if (this.bidPriceTextBoxRef) {
                this.bidPriceTextBoxRef.inputRef.current.focus();
            };
        });
    }

    handleSellerSelectionReset = () => {
        this.setState({ searchSellerPhrase: '', selectedSeller: {}, searchingSellers: false });
    }

    onBidAmountChange = (e, { value }) => {
        this.setState({ bidValue: Number(value) });
    }

    onBidAvailabilityChange = (date) => {
        this.setState({ sellerAvailability: date });
    }

    onValidBidSubmit = async () => {
        this.setState({ showBidPlacementConfirmation: true, bidSubmissionMessage: '' });
    }

    onBidSubmissionClick = async () => {
        this.setState({ loading: true, loadingText: 'Submitting bid', bidSubmissionMessage: '', showBidPlacementConfirmation: false });
        const placeBidResponse = await placeBid(this.props.singleBuyerRequestID, { bidPrice: this.state.bidValue, sellerID: this.state.selectedSeller.id, sellerAvailability: this.state.sellerAvailability });
        if (placeBidResponse.resStatus === 200) {
            this.setState({ selectedSeller: {}, bidValue: 0, submittingBid: false, searchSellerPhrase: '', isUpdated: true }, () => {
                this.fetchBidHistory();
            });
        }
        else {
            this.setState({ bidSubmissionMessage: placeBidResponse.message, submittingBid: false, showBidPlacementConfirmation: false })
        }
    }

    onBidSubmissionCloseOrCancel = () => {
        this.setState({ showBidPlacementConfirmation: false });
    }

    resetState = () => {
        this.setState({ ...initialState });
    }

    getColumnHeaderForSmallerDevices(columnName) {
        if (this.state.windowWidth < 768) {
            return <div className='table-cell-label'>
                {columnName}
            </div>
        }
    }

    displayAvailability = (sellerAvailability) => {
        let availabilityList = '';

        if (sellerAvailability && sellerAvailability.length > 0) {
            availabilityList = _.map(sellerAvailability, (availability) => {
                return moment.tz(availability, this.props.timezone).format('DD MMM YYYY hh:mmA')
            }).join(', ')
        }

        return availabilityList.length > 0 ? availabilityList : '';
    }

    editSellerAvailability = (sellerBidHistoryID, sellerAvailability) => {
        this.setState({ editBidID: sellerBidHistoryID });
    }

    onExistingSellerAvailabilityChange = (date) => {
        this.setState({ newSellerAvailability: date });
    }


    saveSellerAvailability = async () => {
        const response = await updateBidSellerAvailability(this.state.editBidID, { sellerAvailability: this.state.newSellerAvailability.format('YYYY-MM-DD HH:mm:ss') });
        if (response.resStatus === 200) {
            this.setState({ editBidID: 0, newSellerAvailability: null, showAvailabilityUpdateConfirmation: false, isUpdated: true }, () => {
                this.fetchBidHistory();
            });
        }
    }

    confirmSellerAvailabilityEdit = () => {
        this.setState({ showAvailabilityUpdateConfirmation: true });
    }

    cancelEditSellerAvailability = () => {
        this.setState({ editBidID: 0 });
    }

    onChangeAvailabilityConfirmationClose = () => {
        this.setState({ showAvailabilityUpdateConfirmation: false });
    }

    resultRenderer = ({ title, seller }) => {
        return [
            <div key={`content`} className='seller-list-icon'>
                {
                    <img src={seller.subStatus == IN_TRIAL ? marker_trial_purple  : (seller.sellerPlan ? marker_red : marker_green)}>
                    </img>
                }
            </div>,
            <div className='seller-list-title'>{title}</div>
        ]
    }

    render() {
        const { bids } = this.state;
        return (<Modal
            closeIcon
            open={this.props.open}
            className='modal bid-history-modal'
            onClose={this.modalCloseHandler.bind(this)}
        >
            <Header className='modal-header' content={`${this.props.servicename} (${this.props.singleBuyerRequestID})`} />

            <Dimmer.Dimmable as={Modal.Content}>
                <Dimmer active={this.state.submittingBid}>
                    <Loader active={this.state.submittingBid} content="Submitting bid" inverted />
                </Dimmer>
                <Confirm className="confirm"
                    size="large"
                    open={this.state.showBidPlacementConfirmation}
                    closeOnDimmerClick
                    closeOnEscape
                    content="Do you want to continue with the bid placement?"
                    onConfirm={this.onBidSubmissionClick}
                    onCancel={this.onBidSubmissionCloseOrCancel}
                    onClose={this.onBidSubmissionCloseOrCancel}

                />

                <Confirm className="confirm"
                    size="large"
                    open={this.state.showAvailabilityUpdateConfirmation}
                    closeOnDimmerClick
                    closeOnEscape
                    content="Do you want to change seller availability?"
                    onConfirm={this.saveSellerAvailability}
                    onCancel={this.onChangeAvailabilityConfirmationClose}
                    onClose={this.onChangeAvailabilityConfirmationClose}

                />

                {this.props.isRequestAccepted == false &&
                    <Segment>
                        {this.state.bidSubmissionMessage && this.state.bidSubmissionMessage.length > 0 &&
                            <GeneralError message={this.state.bidSubmissionMessage} />
                        }
                        <Formsy onValidSubmit={this.onValidBidSubmit}>
                            <Grid relaxed columns={2} stackable>
                                {!_.isEmpty(this.props.discount) &&
                                    <Grid.Row>
                                        <Grid.Column width={16}>

                                            <div className="bid-modal-promo-display">
                                                Promo Applied: {this.props.discount.discountPercent ? `${this.props.discount.discountPercent}%` : this.props.discount.discountAmount ? `$${this.props.discount.discountAmount}` : ''}
                                            </div>


                                        </Grid.Column>
                                    </Grid.Row>
                                }


                                <Grid.Row>

                                    <Grid.Column computer={_.isEmpty(this.state.selectedSeller) ? 12 : 4} mobile={16}>
                                        <div className="field">
                                            <Search
                                                loading={this.state.searchingSellers}
                                                results={this.state.sellers}
                                                minCharacters={1}
                                                resultRenderer={this.resultRenderer}
                                                onSearchChange={this.onSellerSearchChange}
                                                onResultSelect={this.onSellerSelection}
                                                className="search-box"
                                                placeholder='Search sellers'
                                                value={this.state.searchSellerPhrase}
                                            >

                                            </Search>
                                            {!_.isEmpty(this.state.selectedSeller) && <Icon onClick={this.handleSellerSelectionReset} className='reset-btn' name='close' />}
                                        </div>

                                    </Grid.Column>

                                    {
                                        !_.isEmpty(this.state.selectedSeller) && <React.Fragment>
                                            <Grid.Column computer={4} mobile={16}>

                                                <DGTextbox name="seller-bid-price" label="Bid Price" required
                                                    validations={{
                                                        isMoreThanZero: true,
                                                        isNumeric: true
                                                    }}

                                                    validationErrors={{
                                                        isMoreThanZero: 'The value should be a valid amount',
                                                        isDefaultRequiredValue: 'This field must be provided',
                                                        isNumeric: `This field must be a number`

                                                    }}

                                                    innerRef={(c) => {

                                                        this.bidPriceTextBoxRef = c;
                                                    }}

                                                    onChange={this.onBidAmountChange}

                                                />


                                            </Grid.Column>
                                            <Grid.Column computer={4} mobile={16}>
                                                <DGDateTimePicker
                                                    name="selleravailability"
                                                    label="Availability"
                                                    placeholder=""
                                                    showresetbutton
                                                    onChange={this.onBidAvailabilityChange}
                                                />
                                            </Grid.Column>
                                            <Grid.Column computer={2}>
                                                <Button type="submit" className="btn-primary" >Add Bid</Button>
                                            </Grid.Column>
                                        </React.Fragment>
                                    }
                                </Grid.Row>

                            </Grid>
                        </Formsy>
                    </Segment>
                }
                <Table>
                    {this.state.windowWidth >= 768 && <Table.Header className="table-header">
                        <Table.Row>
                            <Table.HeaderCell style={{ width: '25%' }}>
                                Price
                            </Table.HeaderCell>
                            <Table.HeaderCell style={{ width: '25%' }}>
                                Availability
                            </Table.HeaderCell>
                            <Table.HeaderCell style={{ width: '25%' }}>
                                Seller
                            </Table.HeaderCell>
                            <Table.HeaderCell style={{ width: '25%' }}>
                                Bid On
                            </Table.HeaderCell>

                        </Table.Row>
                    </Table.Header>
                    }
                    <Table.Body className="table-body">
                        {!_.isEmpty(bids) &&
                            bids.map((bid, bidIndex) => {
                                return <Table.Row className={!_.isEmpty(bid.bid.acceptedOn) ? 'accepted-row' : ''}>
                                    <Table.Cell>
                                        {this.getColumnHeaderForSmallerDevices('Price')}
                                        {(bid.bid.discountAmount > 0 || bid.bid.discountPercent > 0) &&
                                            <div><span style={{ textDecoration: 'line-through', width: '75px', display: 'inline-block' }}>{priceDisplay(bid.bid.price)}</span>
                                                <span>{discountedPriceDisplay(bid.bid.price, bid.bid.discountPercent, bid.bid.discountAmount)}</span> </div>}

                                        {(!bid.bid.discountAmount && !bid.bid.discountPercent) && <div>
                                            <span>{priceDisplay(bid.bid.price)}</span>
                                        </div>
                                        }
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.getColumnHeaderForSmallerDevices('Availability')}
                                        {(bid.bid.sellerBidHistoryID != this.state.editBidID) && bid.bid.sellerAvailability && bid.bid.sellerAvailability.length > 0 &&


                                            <div className="edit-availability">{this.displayAvailability(bid.bid.sellerAvailability)}
                                                &nbsp;{this.props.isRequestAccepted == false && <Icon name="edit" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, bid.bid.sellerAvailability[0])}></Icon>}
                                            </div>
                                        }

                                        {(bid.bid.sellerBidHistoryID != this.state.editBidID) && (!bid.bid.sellerAvailability || bid.bid.sellerAvailability.length == 0) && this.props.isRequestAccepted == false &&


                                            <div className="edit-availability">
                                                &nbsp;<Icon name="add circle" onClick={() => this.editSellerAvailability(bid.bid.sellerBidHistoryID, null)}></Icon>
                                            </div>
                                        }

                                        {(bid.bid.sellerBidHistoryID == this.state.editBidID) && this.props.isRequestAccepted == false &&
                                            <React.Fragment>

                                                <div className="edit-availability">
                                                    <Formsy>
                                                        <DGDateTimePicker name="editselleravailability" initialValue={bid.bid.sellerAvailability ? this.displayAvailability(bid.bid.sellerAvailability) : ''} onChange={this.onExistingSellerAvailabilityChange} />
                                                        <div className="save">
                                                            <Icon name="check circle outline" onClick={this.confirmSellerAvailabilityEdit} /> &nbsp;
                                                        </div>
                                                        <div className="cancel">
                                                            <Icon name="delete " onClick={this.cancelEditSellerAvailability} /> &nbsp;
                                                        </div>
                                                    </Formsy>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.getColumnHeaderForSmallerDevices('Seller')}
                                        <div>{bid.seller.name}</div>
                                    </Table.Cell>
                                    <Table.Cell style={!_.isEmpty(bid.bid.acceptedOn) ? { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } : {}}>
                                        {this.getColumnHeaderForSmallerDevices('Date/Time')}
                                        <div>{moment(bid.bid.bidOn).format('MMM DD YYYY')}</div>

                                        {!_.isEmpty(bid.bid.acceptedOn) && <div className="accepted-tag-new">
                                            {/* <div><img src={done}></img></div> */}
                                            <div>Accepted</div>
                                        </div>}
                                    </Table.Cell>
                                </Table.Row>
                            })
                        }
                    </Table.Body>
                </Table>

            </Dimmer.Dimmable>
        </Modal>
        );
    }
}

export default ServiceRequestBidHistoryModal
